import React, { createContext, ReactNode, useState } from "react";

interface Props {
  children: ReactNode;
}

interface ImageContextProps {
  filesContext: { [key: string]: FileList | any };
  setFilesContext: React.Dispatch<React.SetStateAction<FileList | object>>;
  validationTriggered: boolean;
  setValidationTriggered: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ImageContext = createContext<ImageContextProps>({
  filesContext: {},
  setFilesContext: () => {},
  validationTriggered: false,
  setValidationTriggered: () => {},
});

export const ImageStore: React.FC<Props> = ({ children }) => {
  const [filesContext, setFilesContext] = useState<object | any>({});
  const [validationTriggered, setValidationTriggered] = useState(false);

  return (
    <ImageContext.Provider
      value={{ filesContext, setFilesContext, validationTriggered, setValidationTriggered }}
    >
      {children}
    </ImageContext.Provider>
  );
};
